<ion-header>
  <ion-toolbar>
    <ion-title>{{(action === 'add'? 'general.add' : 'general.edit') | translate}} {{'general.supplement' | translate}} {{(mode === 'category'? 'general.category' : 'supplementProtocols.protocol') | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button class="closeBtn" (click)="cancel()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <!-- <ion-buttons slot="end">
      <ion-button color="white" (click)="formData.ngSubmit.emit()">
        Done
      </ion-button>
    </ion-buttons> -->
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form class="formStyle2" #formData='ngForm' (ngSubmit)="onSubmit(formData)"
    [ngClass]="{'submitted': isFormSubmitted}">

    <ion-row>
      <ion-col>
        <ion-item class="ion-no-padding">
          <ion-label position="stacked">{{'general.title' | translate}}</ion-label>
          <ion-textarea autoGrow class="formControl" 
            maxlength="100"
            type="text" #title="ngModel" [(ngModel)]="supplementProtocol.title"
            name="title" required>
            <span class="counter">{{getCounter(supplementProtocol.title, 100)}}</span>
          </ion-textarea>
        </ion-item>
        <div class="field-error" *ngIf="(isFormSubmitted || title.touched) && title.errors?.required">
          <span>{{'general.titleRequired' | translate}}</span>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="type === 'user'">
      <ion-col size-lg="6">
        <ion-item>
          <ion-label position="stacked">{{'general.start' | translate}}</ion-label>
          <div class="datepickerPanel">
            <input [owlDateTimeTrigger]="dtStart" [owlDateTime]="dtStart" #startDate="ngModel" name="startDate"
              class="formControl" [(ngModel)]="dates.start" required>
            <owl-date-time #dtStart [hour12Timer]="true" stepMinute="60"></owl-date-time>
          </div>
        </ion-item>
        <div class="field-error"
          *ngIf="(isFormSubmitted || startDate.touched) && startDate.errors?.required">
          <span>{{'general.start_date_required' | translate}}</span>
        </div>
      </ion-col>

      <ion-col size-lg="6" *ngIf="!premium">
        <ion-item class="toggle">
          <ion-label position="stacked">{{'general.hideProg' | translate}}</ion-label>
          <ion-toggle name="startDateHidden" [disabled]="!dates.start" [(ngModel)]="supplementProtocol.startDateHidden"></ion-toggle>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="type === 'user'">
      <ion-col size-lg="6">
        <ion-item>
          <ion-label position="stacked">{{'general.end' | translate}}</ion-label>
          <div class="datepickerPanel">
            <input [owlDateTimeTrigger]="dtEnd" [owlDateTime]="dtEnd" #endDate="ngModel" name="endDate"
              class="formControl" [(ngModel)]="dates.end" (ngModelChange)="endDateChanged($event)">
            <owl-date-time #dtEnd [hour12Timer]="true" stepMinute="60" [startAt]="endPickerStartAt"></owl-date-time>
          </div>
        </ion-item>
      </ion-col>

      <ion-col size-lg="6" *ngIf="!premium">
        <ion-item class="toggle">
          <ion-label position="stacked">{{'general.hideProdEnd' | translate}}</ion-label>
          <ion-toggle name="endDateHidden" [disabled]="!dates.end" [(ngModel)]="supplementProtocol.endDateHidden"></ion-toggle>
        </ion-item>
      </ion-col>
    </ion-row>
  </form>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" color="secondary" size="small" (click)="formData.ngSubmit.emit()">
        {{'general.submit' | translate}}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
